export default {
      id: "menu__driver-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.svg#menu__driver",
      toString: function () {
        return this.url;
      }
    }